// extracted by mini-css-extract-plugin
export default {"bubble":"SpeechBubble_bubble__N2dI7","expand":"SpeechBubble_expand__iHVKi","shrink":"SpeechBubble_shrink__R8wII"};